<div class="col-md-12 mb-30" >
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">User Sign-in History</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Users</label>
          <select class="custom-select" [(ngModel)]="Selected_User_Id" name="Selected_User_Id">
            <option value="0">All</option>
            <option *ngFor="let item of DataList_User_Option" [value]="item.id">{{item.name}} {{item.familly}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_User(datepickerInputStart.value,datepickerInputEnd.value)"
            class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Full Name</th>
              <th>Sign-in Date</th>
              <th>Browser</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_User| paginate
            : {
                id: 'DataList_UserTable',
                itemsPerPage: 20,
                currentPage: page,
                totalItems: (DataList_User
                ).length
              }">
              <td>{{DataList_User.indexOf(item)+1}}</td>
               <td>{{item.dsc}}</td>
               <td>{{item.title}}</td>
               <td>
                 <i *ngIf="item.code=='edge'" class="fa fa-edge"></i>
                 <i *ngIf="item.code=='firefox'" class="fa fa-firefox"></i>
                 <i *ngIf="item.code=='chrome'" class="fa fa-chrome"></i>
                 <i *ngIf="item.code=='safari'" class="fa fa-safari"></i>
                 <i *ngIf="item.code=='opera'" class="fa fa-opera"></i>
               </td>
             </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_UserTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>



